// extracted by mini-css-extract-plugin
export var lg = "_v-4";
export var md = "_v-3";
export var sm = "_v-2";
export var xs = "_v-1";
export var xxs = "_v-0";